import { createFileRoute, Outlet } from '@tanstack/react-router'

import { redirectNlUsersToPaymentMethods } from '#/shared/routing/redirect-nl-users-to-payment-methods.ts'

export const Route = createFileRoute('/(customer)/_portal/unpaid-invoices')({
  beforeLoad: ({ context }) => redirectNlUsersToPaymentMethods(context),
  component: Outlet,
})
